import { useEffect, useRef } from "react";
import Lenis from "lenis";
import RepairHeader from "../components/repair/RepairHeader";
import RepairHero from "../components/repair/RepairHero";
import RepairMarquee from "../components/repair/RepairMarquee";
import RepairProblems from "../components/repair/RepairProblems";
import RepairWorkshopSteps from "../components/repair/RepairWorkshopSteps";
import RepairProcess from "../components/repair/RepairProcess";
import RepairQuoteForm from "../components/repair/RepairQuoteForm";
import RepairFooter from "../components/repair/RepairFooter";
import WhatsAppFab from "../components/WhatsAppFab";

const OG_IMAGE =
  "https://customer-assets-wrfwihn1.emergentagent.net/job_industrial-shields/artifacts/e72457e01eb8eba9_FB_IMG_1783650592744.jpg";

const SEO = {
  title: "Reparación de Guardas Telescópicas y Fuelles CNC en Querétaro | Guarda Flex",
  description:
    "Soluciones inmediatas para que tu producción no se detenga. Reparación urgente 24/7, reconstrucción y mantenimiento de guardas telescópicas y fuelles CNC en Querétaro y el Bajío. Evaluación técnica preliminar.",
};

export default function ReparacionGuardas() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const prevTitle = document.title;
    const descEl = document.querySelector('meta[name="description"]');
    const prevDesc = descEl?.getAttribute("content");
    document.title = SEO.title;
    descEl?.setAttribute("content", SEO.description);

    const ogTags = [
      ["og:title", SEO.title],
      ["og:description", SEO.description],
      ["og:type", "website"],
      ["og:url", window.location.href],
      ["og:image", OG_IMAGE],
    ];
    const prevOg = {};
    ogTags.forEach(([property, content]) => {
      let el = document.querySelector(`meta[property="${property}"]`);
      if (!el) {
        el = document.createElement("meta");
        el.setAttribute("property", property);
        document.head.appendChild(el);
      }
      prevOg[property] = el.getAttribute("content");
      el.setAttribute("content", content);
    });

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", window.location.href.split("#")[0]);

    // Lenis smooth momentum scrolling (disable native smooth to avoid conflicts)
    const root = document.documentElement;
    const prevScrollBehavior = root.style.scrollBehavior;
    root.style.scrollBehavior = "auto";
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    lenisRef.current = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      lenisRef.current = null;
      root.style.scrollBehavior = prevScrollBehavior;
      document.title = prevTitle;
      if (descEl && prevDesc) descEl.setAttribute("content", prevDesc);
      Object.entries(prevOg).forEach(([property, prev]) => {
        const el = document.querySelector(`meta[property="${property}"]`);
        if (el && prev) el.setAttribute("content", prev);
      });
    };
  }, []);

  const scrollToId = (id) => {
    const el = document.getElementById(id);
    if (!el) return;
    if (lenisRef.current) lenisRef.current.scrollTo(el, { offset: -72 });
    else el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div data-testid="repair-page" className="bg-[#061226] text-white min-h-screen">
      <RepairHeader onNavigate={scrollToId} />
      <main>
        <RepairHero onNavigate={scrollToId} />
        <RepairMarquee />
        <RepairProblems />
        <RepairWorkshopSteps />
        <RepairProcess />
        <RepairQuoteForm />
      </main>
      <RepairFooter />
      <WhatsAppFab />
    </div>
  );
}
